import React from 'react';

import { getPublicAssetUrl } from '@/shared/utils/publicAssetUrl';
import { usePaymentContextFailureResult } from '../hooks/usePaymentContextFailureResult';

const failureIllustrationUrl = getPublicAssetUrl('assets/failure-icon.svg');

export const PayViaLinkFailureResult: React.FC = () => {
  
  const { paymentFailedText, refundMessage } = usePaymentContextFailureResult();

  return (
    <div className="min-h-screen bg-white px-6 py-16">
      <div className="mx-auto flex min-h-[calc(100vh-8rem)] w-full max-w-md flex-col items-center justify-center text-center">
        <img
          src={failureIllustrationUrl}
          alt=""
          className="mb-8 h-auto w-[160px] max-w-full select-none md:w-[190px]"
          aria-hidden="true"
        />

        <h1 className="text-[22px] font-extrabold leading-tight text-[#011E38] md:text-[24px]">
          {paymentFailedText}
        </h1>

        <p className="mt-5 text-base font-medium leading-6 text-[#011E38] md:text-lg md:leading-7">
          {refundMessage}
        </p>
      </div>
    </div>
  );
};

export default PayViaLinkFailureResult;
